import { render, staticRenderFns } from "./regAddressList.vue?vue&type=template&id=4fa69d0a&scoped=true&"
import script from "./regAddressList.vue?vue&type=script&lang=js&"
export * from "./regAddressList.vue?vue&type=script&lang=js&"
import style0 from "./regAddressList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./regAddressList.vue?vue&type=style&index=1&id=4fa69d0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa69d0a",
  null
  
)

export default component.exports